import { render, staticRenderFns } from "./Type.vue?vue&type=template&id=d00a4c04&scoped=true&"
import script from "./Type.vue?vue&type=script&lang=js&"
export * from "./Type.vue?vue&type=script&lang=js&"
import style0 from "./Type.vue?vue&type=style&index=0&id=d00a4c04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00a4c04",
  null
  
)

export default component.exports